var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPicture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.21117 5.4996C3.21171 4.23413 4.2379 3.20863 5.50337 3.20892L15.5005 3.21127C16.766 3.21157 17.7917 4.2375 17.7917 5.50294V15.5011C17.7917 16.7661 16.7666 17.7919 15.5015 17.7928L5.50236 17.7933C4.23735 17.7933 3.2116 16.7683 3.21069 15.5033L3.21117 5.4996ZM13.2635 16.5433L7.87721 10.5574C7.47799 10.1137 6.78834 10.0955 6.36631 10.5175L4.45849 12.4254L4.46069 15.5024C4.46111 16.0774 4.92736 16.5433 5.50236 16.5433H13.2635ZM10.7083 8.83331C10.7083 7.56766 11.7343 6.54165 13 6.54165C14.2656 6.54165 15.2916 7.56766 15.2916 8.83331C15.2916 10.099 14.2656 11.125 13 11.125C11.7343 11.125 10.7083 10.099 10.7083 8.83331Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPicture);
export default __webpack_public_path__ + "static/media/icon-picture.90ad45d4c1915f3efc8189ef2de32083.svg";
export { ForwardRef as ReactComponent };